import { AppCatalogCategoryService } from "../resource";
import { visibilityReadyFrom } from "../utils/categoryVisibility";

const AppCatalogCategoryModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null,
        current: null,
        // false until the list response says `visibility_ready: true` — the
        // channel switches stay disabled until the SQL is applied (spec E1).
        visibilityReady: false
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        },
        SET_CURRENT(state, item) {
            state.current = item;
        },
        SET_VISIBILITY_READY(state, val) {
            state.visibilityReady = !!val;
        }
    },
    actions: {
        async fetchList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogCategoryService.list(params);
                const data = (res.data && res.data.data) ? res.data.data : [];
                commit("SET_LIST", data);
                commit("SET_TOTAL", data.length);
                commit("SET_VISIBILITY_READY", visibilityReadyFrom(res.data));
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_VISIBILITY_READY", false);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchOne({ commit }, id) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogCategoryService.get(id);
                commit("SET_CURRENT", (res.data && res.data.data) ? res.data.data : null);
            } catch (err) {
                commit("SET_CURRENT", null);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        create(_, payload) {
            return AppCatalogCategoryService.create(payload);
        },
        update(_, { id, payload }) {
            return AppCatalogCategoryService.update(id, payload);
        },
        remove(_, id) {
            return AppCatalogCategoryService.remove(id);
        },
        // One channel flag per call — payload built by visibilityPatch().
        setVisibility(_, { id, payload }) {
            return AppCatalogCategoryService.setVisibility(id, payload);
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error,
        current: state => state.current,
        visibilityReady: state => state.visibilityReady
    }
};

export default AppCatalogCategoryModule;
